
var ContextControl = (function () {
  var COPYRIGHT = "(c) Copyright The Australian e-Health Research Centre, CSIRO, 2019",
    debug,
    csRadioElt, vsRadioElt, eclRadioElt,
    csElt, versElt, filterElt, vsElt, eclElt,
    eclQueries,
    selected = {},
    currentView,
    currentFilter,
    csFilter,
    vsFilter,
    listeners = [],
    viewListeners = [];

  return {
    settings: {
      defaultView: undefined,
      csId: "#codesystem",
      csLimit: "#cslimit",
      versId: "#version",
      filterId: "#filter",
      vsId: "#vsfilter",
      vsLimit: "#vslimit",
      eclId: "#eclfilter",
      csRadioId: "#csradio",
      vsRadioId: "#vsradio",
      eclRadioId: "#eclradio",
    },

    init: function (flag) {
      debug = function () {
        if (flag) console.log.apply(this, arguments);
      }
      debug('ContextControl.init');

      var s = this.settings;

      // Snapper ValueSets
      // console.log('VS', JSON.parse(window.localStorage.getItem('ngStorage-valueSets'))||'[]');

      currentView = s.defaultView;

      if (s.csId) {
        currentView = currentView || 'cs';
        csRadioElt = d3.select(s.csRadioId);
        csElt = d3.select(s.csId);
        versElt = d3.select(s.versId);
        filterElt = d3.select(s.filterId);

        if ('cs' === currentView) csRadioElt.property('checked', true);

        const limit = d3.select(s.csLimit);
        const doFilter = () => {
          const text = limit.node().value;
          csFilter(text || '');
        };

        limit.on("keyup", doFilter);
        limit.on("search", doFilter);

        csElt.on("change", HistoryManager.userAction(codeSystemChanged));
        versElt.on("change", HistoryManager.userAction(versionChanged));
        filterElt.on("change", HistoryManager.userAction(filterChanged));
        csRadioElt.on("change", HistoryManager.userAction(radioChanged));
      }
      if (s.vsId) {
        currentView = currentView || 'vs';
        vsRadioElt = d3.select(s.vsRadioId);
        vsElt = d3.select(s.vsId);

        if ('vs' === currentView) vsRadioElt.property('checked', true);

        /*
                vsElt
                  .append("option")
                    .style('color', 'grey')
                    .text(" ");
        */

        const limit = d3.select(s.vsLimit);
        const doFilter = () => {
          const text = limit.node().value;
          vsFilter(text || '');
        };

        limit.on("keyup", doFilter);
        limit.on("search", doFilter);

        vsElt.on("change", HistoryManager.userAction(filterChanged));
        vsRadioElt.on("change", HistoryManager.userAction(radioChanged));
      }
      if (s.eclId) {
        currentView = currentView || 'ecl';
        eclRadioElt = d3.select(s.eclRadioId);
        eclElt = d3.select(s.eclId);

        if ('ecl' === currentView) eclRadioElt.property('checked', true);

        var queries = JSON.parse(window.localStorage.getItem('queries') || '{}')

        var keys = Object.keys(queries).filter(function (d) { return queries[d].ecl; }),
          f = eclElt
            .selectAll(".eclSet")
            .data(keys);

        f.enter().append("option")
          .attr("class", "eclSet")
          .attr("url", function (d) { return 'http://snomed.info/sct?fhir_vs=ecl/' + toCanonicalEcl(queries[d].ecl); })
          .attr("title", function (d) { return queries[d].ecl; })
          .attr("id", function (d) { return d; })
          .text(function (d) {
            var name = queries[d].name;
            return name.startsWith('Untitled-') ? (name + ' ( ' + toCanonicalEcl(queries[d].ecl) + ' )') : name;
          });
        f.exit()
          .remove();
      }

      eclElt.on("change", HistoryManager.userAction(filterChanged));
      eclRadioElt.on("change", HistoryManager.userAction(radioChanged));
    },

    initView: function (view) {
      if ('cs' === view || 'vs' === view || 'ecl' === view) this.settings.defaultView = view;
    },

    getTlc: function () {
      if (csRadioElt && csRadioElt.property('checked')) {
        const system = getSelectedCodeSystem();
        return system && {
          "resourceType": "ValueSet",
          "compose": {
            "include": [{
              "system": system,
              "version": getSelectedVersion(),
              "filter": [{ property: 'parent', op: 'exists', value: 'false' }],
            }],
          },
        };
      }
    },

    setFocus: function (focus) {
      selected.s = focus.s;
      selected.sv = focus.sv;
      selected.v = focus.v;
      selected.f = focus.f;
    },

    setView: function (view) {
      if ('cs' === view && csRadioElt) {
        csRadioElt.property('checked', true);
        radioChanged();
      }
      if ('vs' === view && vsRadioElt) {
        vsRadioElt.property('checked', true);
        radioChanged();
      }
      if ('ecl' === view && eclRadioElt) {
        eclRadioElt.property('checked', true);
        radioChanged();
      }
    },

    setEndpoint: function (url) {
      // Reference Sets
      if (csElt) {
        var codeSystems = VersionManager.getCodeSystems(),
          csId;

        csId = updateCodeSystems(csElt, codeSystems, selected.s);
        csFilter = (text) => {
          const csf = codeSystems.filter((d, i) => d.id == selected.s || csMatch(d, text, i));
          updateCodeSystems(csElt, csf, selected.s);
        }
        selected.s = csId || (codeSystems[0] && codeSystems[0].id);
        codeSystemChanged();
      }

      // ValueSets
      if (vsElt) {
        var valueSetId = (getSelectedFilter() || {}).id;

        VersionManager.getValueSets(function (vs) {
          vs = sortByLabel(vs.filter(function (d) { return d.url; }));

          updateValueSets(vsElt, vs, valueSetId);
          vsFilter = (text) => {
            const vsf = vs.filter((d, i) => vsMatch(d, text, i));
            updateValueSets(vsElt, vsf, (getSelectedFilter() || {}).id);
          }

          filterChanged();
        });
      }
    },

    addListener: function (listener) { listeners.push(listener); },
    addViewListener: function (listener) { viewListeners.push(listener); },
  };

  function csMatch(d, terms, i) {
    const llabel = d.name.toLocaleLowerCase();
    const lterms = terms.toLocaleLowerCase();
    return lterms.split(/\s+/).filter(t => llabel.indexOf(t) < 0).length === 0;
  }

  function vsMatch(d, terms, i) {
    const llabel = d.label.toLocaleLowerCase();
    const lterms = terms.toLocaleLowerCase();
    return lterms.split(/\s+/).filter(t => llabel.indexOf(t) < 0).length === 0;
  }

  function updateCodeSystems(csElt, codeSystems, selectedCodeSystem) {
    var csId;
    var ed = csElt.selectAll(".ed")
      .data(codeSystems, function (d) { return d.id; });

    if (codeSystems.length <= 1) {
      csElt.attr("disabled", true)
      csElt.style('background', 'lightgrey')
    } else {
      csElt.attr("disabled", undefined)
      csElt.style('background', 'white')
    }

    ed.enter()
      .append("option")
      .attr("class", "ed")
      .attr("id", function (d) { return d.id; })
      .attr("selected", function (d, i) { if (d.id === selectedCodeSystem) { csId = d.id; return "selected"; } else { return null; } })
      .text(function (d) { return d.name; });

    ed.exit().remove();
    ed.order();

    return csId;
  }

  function updateValueSets(vsElt, vs, valueSetId) {
    var f = vsElt.selectAll(".vsfilterSet")
      .data(vs, function (d) { return d.id; });

    if (vs.length === 0) {
      vsElt.attr("disabled", true)
      vsElt.style('background', 'lightgrey')
    } else {
      vsElt.attr("disabled", undefined)
      vsElt.style('background', 'white')
    }

    f.enter().append("option")
      .attr("class", "vsfilterSet")
      .attr("id", function (d) { return d.id; })
      .attr("url", function (d) { return d.url; })
      .attr("description", function (d) { return d.description; })
      .attr("publisher", function (d) { return d.publisher; })
      .attr("version", function (d) { return d.version; })
      .attr("title", function (d) { return "ID:  " + d.id + "\nURL: " + d.url; })
      .attr("selected", function (d) { var s = valueSetId === d.id; return s ? "selected" : null; })
      .text(function (d) {
        var t = Endpoint.trimLabel(d.label).replace(/\s*reference set\s*$/i, "");
        return t;
      });
    f.exit().remove();
    f.order();
  }

  function notify(who, payload) {
    who.forEach(function (callback) {
      try {
        callback(payload);
      } catch (err) {
        console.log('endpoint', callback, err);
      }
    });
  }

  function sortByLabel(list) {
    return list.sort(function (a, b) { return a.label < b.label ? -1 : (b.label < a.label ? 1 : 0); });
  }

  function groupVersions(cs, versions) {
    var groups = {};
    if ("http://snomed.info/sct" === cs) {
      versions.forEach(function (v) {
        if (v.id.indexOf('/version/') < 0) {
          var key = ' Latest ';
          groups[key] = (groups[key] || []);
          groups[key].push(v);
        } else {
          var key = v.vers.split(/-/)[0];
          groups[key] = (groups[key] || []);
          groups[key].push(v);
        }
      });
    } else {
      groups[cs] = versions;
    }
    return groups;
  }

  function codeSystemChanged() {
    var cs = getSelectedCodeSystem(),
      versions = VersionManager.getVersions(cs),
      versionGroups = groupVersions(cs, versions),
      groups = Object.keys(versionGroups),
      grps = versElt
        .selectAll(".vgrp")
        .data(groups, function (d) { return "_" + d; });

    grps.enter()
      .append('optgroup')
      .attr("class", "vgrp")
      .attr("label", function (d) { return d; })
      .each(function (d) {
        var vers = d3.select(this)
          .selectAll(".vers").data(versionGroups[d], function (d) { return d.id; });

        vers.enter()
          .append("option")
          .attr("class", "vers")
          .attr("id", function (d) { return d.id; })
          .attr("date", function (d) { return d.date; })
          .attr("selected", function (d) { var s = selected.sv === d.id; return s ? "selected" : null; })
          .text(function (d) { return d.vers; });

        vers.exit().remove();
      });
    grps.exit().remove();

    versionChanged();
  }

  var versionState;

  function versionChanged() {
    var cs = getSelectedCodeSystem(),
      csName = getSelectedCodeSystemName(),
      vers = getSelectedVersion(),
      vs = VersionManager.getCodeSystemValueSet(cs, vers);

    versionState = cs + '|' + vers;

    VersionManager.getReferenceSets(cs, vers, function (rs) {
      if (versionState !== cs + '|' + vers) {
        return;
      }
      rs = sortByLabel(rs);

      if (vs) {
        rs.unshift({ id: vs, label: ' All ' + csName + ' Codes' });
      }

      var f = filterElt
        .selectAll(".filterSet")
        .data(rs, function (d) { return d.id; });

      f.enter().append("option")
        .attr("class", "filterSet")
        .attr("url", function (d) { return d.id; })
        .attr("id", function (d) { return d.id; })
        .attr("selected", function (d) { var s = selected.v === d.id; return s ? "selected" : null; })
        .text(function (d) {
          return Endpoint.trimLabel(d.label); //.replace(/\s*reference set.*$/i, "");
        });
      f.exit()
        .remove();

      filterChanged();
    });
  }
  function radioChanged() {
    var view;
    if (csRadioElt && csRadioElt.property('checked')) {
      view = 'cs';
    } else if (vsRadioElt && vsRadioElt.property('checked')) {
      view = 'vs';
    } else if (eclRadioElt && eclRadioElt.property('checked')) {
      view = 'ecl';
    }
    if (currentView !== view) {
      currentView = view;
      notify(viewListeners, currentView);
      filterChanged();
    }
  }
  function filterChanged() {
    var filter = getSelectedFilter();
    if (currentFilter && filter && currentFilter.v === filter.v && currentFilter.t === filter.t && currentFilter.i === filter.i && currentFilter.version === filter.version) {
      currentFilter = filter;
      return;
    }

    currentFilter = filter;
    notify(listeners, filter || []);
  }

  function getSelectedCodeSystem() {
    var sel = getSelection(csElt);
    return sel && sel.id;
  }
  function getSelectedCodeSystemName() {
    var sel = getSelection(csElt);
    return sel && sel.text;
  }
  function getSelectedVersion() {
    var sel = getSelection(versElt);
    return sel && sel.id;
  }
  function getSelectedDate() {
    var sel = getSelection(versElt);
    return sel && sel.getAttribute('date');
  }
  function getSelectedFilter() {
    var opt, system, version, date;
    if (csRadioElt && csRadioElt.property('checked')) {
      opt = getSelection(filterElt);
      system = getSelectedCodeSystem();
      version = canonicalVersion(system, getSelectedVersion());
      date = getSelectedDate();
    } else if (vsRadioElt && vsRadioElt.property('checked')) {
      opt = getSelection(vsElt);
    } else if (eclRadioElt && eclRadioElt.property('checked')) {
      opt = getSelection(eclElt);
    }
    if (opt) {
      var url = opt.getAttribute('url'),
        id = opt.getAttribute('id'),
        label = opt.text,
        result = { v: url, i: id, t: label, s: system, version: version, date: date };
      ['id', 'description', 'publisher'].forEach(function (k) {
        result[k] = opt.getAttribute(k);
      });
      return result;
    }
  }
  function getSelection(elt) {
    var e = elt.node(),
      selected = e.options[e.selectedIndex];

    if (!selected && e.options.length) {
      selected = e.options[0];
      e.value = selected.value;
    }
    return selected;
  }
  function canonicalVersion(system, version) {
    return system + '|' + version;
  }

  function toCanonicalEcl(ecl) {
    // trim concept labels and excess whitespace
    return ecl && ecl.replace(/\|[^|]*\|/g, ' ').replace(/[ \t\n]+/g, ' ');
  }

})();

